{
  "sectionId": "participantProviderRates",
  "header": "Participant - Personal Assistant Rates",
  "available_actions": null,
  "attributes": [
    {
      "attribute_ID": "participant_lkp",
      "fieldName": "participant_lkp",
      "label": "Participant",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Select a Participant",
      "isAvailable": "Y",
      "placeholder": "Participant"
    },
    {
      "attribute_ID": "provider_lkp",
      "fieldName": "provider_lkp",
      "label": "Personal Assistant",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select the Personal Assistant",
      "isAvailable": "Y",
      "placeholder": "Personal Assistant"
    },
    {
      "attribute_ID": "rate",
      "fieldName": "rate",
      "label": "Rate",
      "type": "input",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please enter the rate.",
      "isAvailable": "Y",
      "placeholder": "Rate"
    },
    {
      "attribute_ID": "code",
      "fieldName": "code",
      "label": "Service code",
      "type": "select",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select a service code.",
      "isAvailable": "Y"
    },
    {
      "attribute_ID": "fromdate",
      "fieldName": "fromdate",
      "label": "Start Date",
      "type": "datepicker",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select start date",
      "isAvailable": "Y",
      "placeholder": "MM/DD/YYYY"
    },
    {
      "attribute_ID": "todate",
      "fieldName": "todate",
      "label": "End Date",
      "type": "datepicker",
      "mandatory": "N",
      "validator": null,
      "tooltip": "Please select end date",
      "isAvailable": "Y",
      "placeholder": "MM/DD/YYYY"
    }
  ],
  "validations": [
    {
      "whatToCheck": "atLeastXEntered",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "checkFieldValue",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "conditionalCheck",
      "clientOrServer": "C",
      "attributes": []
    },
    {
      "whatToCheck": "customValidator",
      "clientOrServer": "C",
      "attributes": []
    }
  ],
  "actions": [
    {
      "Name": "Previous",
      "Validate": null
    },
    {
      "Name": "Next",
      "Validate": [
        {
          "checkType": "atLeastXEntered",
          "validatorid": []
        },
        {
          "checkType": "checkFieldValue",
          "validatorid": []
        },
        {
          "checkType": "conditionalCheck",
          "validatorid": []
        },
        {
          "checkType": "customValidator",
          "validatorid": []
        }
      ]
    }
  ]
}
